import * as actionTypes from "./actionTypes";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import {
  getSchedulesDefinitionAPI,
  createSchedulesDefinitionAPI,
  updateSchedulesDefinitionAPI,
  deleteSchedulesDefinitionAPI,
} from "@icarius-connection/api";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    case "DUPLICATED_DATA":
      errorString = getLocalizedString("scheduleWithSameCodeOrNameAlreadyExists");
      break;
    case "IN_USE":
      errorString = getLocalizedString("scheduleDefinitionInUse");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}

export const getSchedulesDefinitionAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET_ROWS });
  try {
    let response = await getSchedulesDefinitionAPI();

    let rows = response.data && response.data.data;

    dispatch({
      type: actionTypes.GET_ROWS_FULFILLED,
      payload: { rows }
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_ROWS_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const createSchedulesDefinitionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE });
  try {
    let response = await createSchedulesDefinitionAPI(data);
    let rows = response.data && response.data.data;

    dispatch({
      type: actionTypes.CREATE_FULFILLED,
      payload: { rows }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("scheduleCreatedSuccessfullyAlt"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.CREATE_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const updateSchedulesDefinitionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.MODIFY });
  try {
    let response = await updateSchedulesDefinitionAPI(data);
    let rows = response.data && response.data.data;

    dispatch({
      type: actionTypes.MODIFY_FULFILLED,
      payload: { rows }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("scheduleModifiedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.MODIFY_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const deleteSchedulesDefinitionAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE });
  try {
    let response = await deleteSchedulesDefinitionAPI(data);
    let rows = response.data && response.data.data;
    
    dispatch({
      type: actionTypes.DELETE_FULFILLED,
      payload: { rows }
    });
    dispatch(openSnackbarAction({ msg: getLocalizedString("scheduleDeletedSuccessfully"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.DELETE_REJECTED, payload: e });
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    errorHandler(e, dispatch);
  }
};